/** Role IDs as seeded in the database — single source of truth for the UI. */
export const AppRoles = {
    ThirdParty: 'ARES.ThirdParty',
    ThirdPartyAdmin: 'ARES.ThirdPartyAdmin',
} as const;

export type AppRoleId = (typeof AppRoles)[keyof typeof AppRoles];
